var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#191818",
    strokeWidth: 2,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.002 1 16 16M17 1 1 17"
  })));
};
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMTkxODE4IiBzdHJva2Utd2lkdGg9IjIiPgogIDxwYXRoIGQ9Ik0xLjAwMTc4IDEuMDAwNjZMMTcuMDAyIDE2Ljk5OTMiLz4KICA8cGF0aCBkPSJNMTcuMDAwMiAxLjAwMDY2TDAuOTk5OTUgMTYuOTk5MyIvPgo8L3N2Zz4=";